export enum CustomClass {
  MAIN_BLOCK = "fix-block_main-block",
  CLOSE_BUTTON = "fix-block_close-button",
  CONTAINER = "fix-block_container",
  OFFER = "fix-block_offer",
  MAIN_BUTTON = "fix-block_main-button",
  IMAGE = "fix-block_image",
  MINI_WIDGET = "fix-block_mini-widget"
}